import reorderAll from 'utils/reorderAll'

interface getReorderRowsProps {
  data: Array<any>
  sortRowsUrl: string
}

const reorderRows = async (props: getReorderRowsProps) => {
  const data = await reorderAll(props.sortRowsUrl, props.data)

  return data
}

export default reorderRows
